export const stats = [
  {
    data: "35K",
    title: "Customers",
  },
  {
    data: "10K+",
    title: "Downloads",
  },
  {
    data: "40+",
    title: "Countries",
  },
  {
    data: "30M+",
    title: "Total revenue",
  },
];

export const testimonials = [
  {
    avatar: "https://api.uifaces.co/our-content/donated/xZ4wg2Xj.jpg",
    name: "Martin escobar",
    title: "Customer",
    quote:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nunc et est hendrerit, porta nunc vitae, gravida justo. Nunc fermentum magna lorem, euismod volutpat arcu volutpat et.",
  },
  {
    avatar: "https://randomuser.me/api/portraits/women/79.jpg",
    name: "Angela stian",
    title: "Customer",
    quote:
      "It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout, that the point of using Lorem Ipsum.",
  },
  {
    avatar: "https://randomuser.me/api/portraits/men/86.jpg",
    name: "Karim ahmed",
    title: "Customer",
    quote:
      "At vero eos et accusamus et iusto odio dignissimos ducimus qui blanditiis praesentium voluptatum deleniti atque corrupti quos dolores et quas molestias excepturi sint occaecati ",
  },
];

export const team = [
  {
    avatar: "https://ca.slack-edge.com/T05QKNCTHM4-U05QSC0S5C2-ee40c928bbc0-72",
    name: "Anthony Harold",
    title: "Coordinator & Full Stack Developer",
    desc: "Lorem Ipsum is simply dummy text of the printing and typesettin industry.",
    linkedin: "www.google.com",
    twitter: "www.google.com",
  },
  {
    avatar:
      "https://ca.slack-edge.com/T05QKNCTHM4-U05R58444RF-ae87c512fd49-512",
    name: "Ethan Specter",
    title: "Director",
    desc: "Lorem Ipsum is simply dummy text of the printing and typesettin industry.",
    linkedin: "www.google.com",
    twitter: "www.google.com",
  },
  {
    avatar:
      "https://ca.slack-edge.com/T05QKNCTHM4-U05T9UZCLBA-efb197e93105-512",
    name: "Prof.Noah Adams",
    title: "Full Stack Developer",
    desc: "Lorem Ipsum is simply dummy text of the printing and typesettin industry.",
    linkedin: "www.google.com",
    twitter: "www.google.com",
  },
  {
    avatar:
      "https://ca.slack-edge.com/T05QKNCTHM4-U05QN7K2FPG-20f1a93fe8d0-512",
    name: "Felix Franko",
    title: "Full Stack Developer",
    desc: "Lorem Ipsum is simply dummy text of the printing and typesettin industry.",
    linkedin: "www.google.com",
    twitter: "www.google.com",
  },
  {
    avatar:
      "https://ca.slack-edge.com/T05QKNCTHM4-U05SLS3GC4S-ee2565a13466-512",
    name: "Harvey Watson",
    title: "Full Stack Developer",
    desc: "Lorem Ipsum is simply dummy text of the printing and typesettin industry.",
    linkedin: "www.google.com",
    twitter: "www.google.com",
  },
  {
    avatar:
      "https://ca.slack-edge.com/T05QKNCTHM4-U05SC5CSZ2T-b5cd0d5a4f9d-512",
    name: "Helen Kuttery",
    title: "Full Stack Developer",
    desc: "Lorem Ipsum is simply dummy text of the printing and typesettin industry.",
    linkedin: "www.google.com",
    twitter: "www.google.com",
  },
];
